export const sharedAgentModelSelectionDe = {
  "AgentModelSelection.Requirements": "Benötigt: {capabilities}",
  "AgentModelSelection.Capability.Text": "Text",
  "AgentModelSelection.Capability.Image": "Bildverständnis",
  "AgentModelSelection.Capability.Document": "Dokumentverständnis",
  "AgentModelSelection.Capability.Audio": "Audioverständnis",
  "AgentModelSelection.Capability.Video": "Videoverständnis",
  "AgentModelSelection.Block.MissingInputCapability": "{capabilities} fehlt",
  "AgentModelSelection.Block.InputCapabilitiesUnknown": "Eingabefähigkeiten wurden nicht ermittelt",
  "AgentModelSelection.Block.ExecutionLocationMismatch": "Für diesen Verarbeitungsstandort nicht freigegeben",
  "AgentModelSelection.Block.ExecutionRegionMismatch": "erfüllt die geforderte EU-Verarbeitung nicht",
  "AgentModelSelection.Block.InfrastructureOperatorMismatch": "wird nicht in mQorva-Infrastruktur ausgeführt",
  "AgentModelSelection.Block.ModelDisabled": "Modell ist deaktiviert",
  "AgentModelSelection.Block.CatalogEntryMissing": "Modell ist nicht mehr im Katalog",
  "AgentModelSelection.Block.OperationTypeMismatch": "Falsche Modellart",
  "AgentModelSelection.CurrentAssignmentInvalid": "Die aktuelle Zuweisung ist nicht ausführbar: {reason}",
  "AgentModelSelection.CurrentAssignmentGroup": "Aktuelle Zuweisung",
  "AgentModelSelection.Empty": "Keine Modelle dieser Modellart vorhanden",
  "AgentModelSelection.Placeholder": "Modell auswählen",
  "AgentModelSelection.Warning.ProviderUnavailable": "Providerzugang ist derzeit nicht ausführbar",
  "AgentModelSelection.Warning.DocumentViaOcr": "Dokumente werden über OCR aus Seitenbildern gelesen.",
  "AgentModelSelection.Warning.PriceMissing": "Preis für dieses Modell fehlt",
  "AgentModelSelection.Warning.PriceStale": "Preis für dieses Modell ist nicht aktuell",
  "AgentModelSelection.Warning.InternalPriceMissing": "Interne Kostenbasis für dieses Modell fehlt",
  "AgentModelSelection.Warning.PricingUnsupported": "Das Abrechnungsmodell wird noch nicht unterstützt",
} as const;

export const sharedAgentModelSelectionEn = {
  "AgentModelSelection.Requirements": "Requires: {capabilities}",
  "AgentModelSelection.Capability.Text": "text",
  "AgentModelSelection.Capability.Image": "image understanding",
  "AgentModelSelection.Capability.Document": "document understanding",
  "AgentModelSelection.Capability.Audio": "audio understanding",
  "AgentModelSelection.Capability.Video": "video understanding",
  "AgentModelSelection.Block.MissingInputCapability": "Missing: {capabilities}",
  "AgentModelSelection.Block.InputCapabilitiesUnknown": "Input capabilities have not been determined",
  "AgentModelSelection.Block.ExecutionLocationMismatch": "not approved for this processing location",
  "AgentModelSelection.Block.ExecutionRegionMismatch": "does not meet the required EU processing guarantee",
  "AgentModelSelection.Block.InfrastructureOperatorMismatch": "is not executed on mQorva-operated infrastructure",
  "AgentModelSelection.Block.ModelDisabled": "model is disabled",
  "AgentModelSelection.Block.CatalogEntryMissing": "model is no longer in the catalogue",
  "AgentModelSelection.Block.OperationTypeMismatch": "wrong model type",
  "AgentModelSelection.CurrentAssignmentInvalid": "The current assignment cannot be executed: {reason}",
  "AgentModelSelection.CurrentAssignmentGroup": "Current assignment",
  "AgentModelSelection.Empty": "No models of this type are available",
  "AgentModelSelection.Placeholder": "Select model",
  "AgentModelSelection.Warning.ProviderUnavailable": "Provider access is currently unavailable",
  "AgentModelSelection.Warning.DocumentViaOcr": "Documents are read through OCR from page images.",
  "AgentModelSelection.Warning.PriceMissing": "Pricing for this model is missing",
  "AgentModelSelection.Warning.PriceStale": "Pricing for this model is outdated",
  "AgentModelSelection.Warning.InternalPriceMissing": "Internal cost basis for this model is missing",
  "AgentModelSelection.Warning.PricingUnsupported": "This billing model is not supported yet",
} as const;

export const sharedAgentModelSelectionRu = {
  "AgentModelSelection.Requirements": "Требуется: {capabilities}",
  "AgentModelSelection.Capability.Text": "текст",
  "AgentModelSelection.Capability.Image": "понимание изображений",
  "AgentModelSelection.Capability.Document": "понимание документов",
  "AgentModelSelection.Capability.Audio": "понимание аудио",
  "AgentModelSelection.Capability.Video": "понимание видео",
  "AgentModelSelection.Block.MissingInputCapability": "Отсутствует: {capabilities}",
  "AgentModelSelection.Block.InputCapabilitiesUnknown": "Входные возможности не определены",
  "AgentModelSelection.Block.ExecutionLocationMismatch": "не разрешено для этого места обработки",
  "AgentModelSelection.Block.ExecutionRegionMismatch": "не соответствует требованию обработки в ЕС",
  "AgentModelSelection.Block.InfrastructureOperatorMismatch": "не выполняется в инфраструктуре mQorva",
  "AgentModelSelection.Block.ModelDisabled": "модель отключена",
  "AgentModelSelection.Block.CatalogEntryMissing": "модели больше нет в каталоге",
  "AgentModelSelection.Block.OperationTypeMismatch": "неподходящий тип модели",
  "AgentModelSelection.CurrentAssignmentInvalid": "Текущее назначение нельзя выполнить: {reason}",
  "AgentModelSelection.CurrentAssignmentGroup": "Текущее назначение",
  "AgentModelSelection.Empty": "Нет моделей этого типа",
  "AgentModelSelection.Placeholder": "Выбрать модель",
  "AgentModelSelection.Warning.ProviderUnavailable": "Доступ к провайдеру сейчас недоступен",
  "AgentModelSelection.Warning.DocumentViaOcr": "Документы читаются с изображений страниц с помощью OCR.",
  "AgentModelSelection.Warning.PriceMissing": "Цена для этой модели отсутствует",
  "AgentModelSelection.Warning.PriceStale": "Цена для этой модели устарела",
  "AgentModelSelection.Warning.InternalPriceMissing": "Внутренняя стоимость этой модели отсутствует",
  "AgentModelSelection.Warning.PricingUnsupported": "Эта модель тарификации пока не поддерживается",
} as const;

export const sharedAgentModelSelectionUk = {
  "AgentModelSelection.Requirements": "Потрібно: {capabilities}",
  "AgentModelSelection.Capability.Text": "текст",
  "AgentModelSelection.Capability.Image": "розуміння зображень",
  "AgentModelSelection.Capability.Document": "розуміння документів",
  "AgentModelSelection.Capability.Audio": "розуміння аудіо",
  "AgentModelSelection.Capability.Video": "розуміння відео",
  "AgentModelSelection.Block.MissingInputCapability": "Відсутнє: {capabilities}",
  "AgentModelSelection.Block.InputCapabilitiesUnknown": "Вхідні можливості не визначено",
  "AgentModelSelection.Block.ExecutionLocationMismatch": "не дозволено для цього місця обробки",
  "AgentModelSelection.Block.ExecutionRegionMismatch": "не відповідає вимозі обробки в ЄС",
  "AgentModelSelection.Block.InfrastructureOperatorMismatch": "не виконується в інфраструктурі mQorva",
  "AgentModelSelection.Block.ModelDisabled": "модель вимкнена",
  "AgentModelSelection.Block.CatalogEntryMissing": "моделі більше немає в каталозі",
  "AgentModelSelection.Block.OperationTypeMismatch": "невідповідний тип моделі",
  "AgentModelSelection.CurrentAssignmentInvalid": "Поточне призначення неможливо виконати: {reason}",
  "AgentModelSelection.CurrentAssignmentGroup": "Поточне призначення",
  "AgentModelSelection.Empty": "Немає моделей цього типу",
  "AgentModelSelection.Placeholder": "Вибрати модель",
  "AgentModelSelection.Warning.ProviderUnavailable": "Доступ до провайдера зараз недоступний",
  "AgentModelSelection.Warning.DocumentViaOcr": "Документи читаються із зображень сторінок за допомогою OCR.",
  "AgentModelSelection.Warning.PriceMissing": "Ціна для цієї моделі відсутня",
  "AgentModelSelection.Warning.PriceStale": "Ціна для цієї моделі застаріла",
  "AgentModelSelection.Warning.InternalPriceMissing": "Внутрішня вартість цієї моделі відсутня",
  "AgentModelSelection.Warning.PricingUnsupported": "Ця модель тарифікації ще не підтримується",
} as const;

export const sharedAgentModelSelectionIt = {
  "AgentModelSelection.Requirements": "Richiede: {capabilities}",
  "AgentModelSelection.Capability.Text": "testo",
  "AgentModelSelection.Capability.Image": "comprensione delle immagini",
  "AgentModelSelection.Capability.Document": "comprensione dei documenti",
  "AgentModelSelection.Capability.Audio": "comprensione audio",
  "AgentModelSelection.Capability.Video": "comprensione video",
  "AgentModelSelection.Block.MissingInputCapability": "Manca: {capabilities}",
  "AgentModelSelection.Block.InputCapabilitiesUnknown": "Le capacità di input non sono state determinate",
  "AgentModelSelection.Block.ExecutionLocationMismatch": "non autorizzato per questa sede di elaborazione",
  "AgentModelSelection.Block.ExecutionRegionMismatch": "non soddisfa il requisito di elaborazione nell'UE",
  "AgentModelSelection.Block.InfrastructureOperatorMismatch": "non viene eseguito su infrastruttura gestita da mQorva",
  "AgentModelSelection.Block.ModelDisabled": "il modello è disattivato",
  "AgentModelSelection.Block.CatalogEntryMissing": "il modello non è più nel catalogo",
  "AgentModelSelection.Block.OperationTypeMismatch": "tipo di modello errato",
  "AgentModelSelection.CurrentAssignmentInvalid": "L'assegnazione attuale non può essere eseguita: {reason}",
  "AgentModelSelection.CurrentAssignmentGroup": "Assegnazione attuale",
  "AgentModelSelection.Empty": "Non sono disponibili modelli di questo tipo",
  "AgentModelSelection.Placeholder": "Seleziona modello",
  "AgentModelSelection.Warning.ProviderUnavailable": "L'accesso al provider non è attualmente disponibile",
  "AgentModelSelection.Warning.DocumentViaOcr": "I documenti vengono letti tramite OCR dalle immagini delle pagine.",
  "AgentModelSelection.Warning.PriceMissing": "Il prezzo per questo modello non è disponibile",
  "AgentModelSelection.Warning.PriceStale": "Il prezzo per questo modello non è aggiornato",
  "AgentModelSelection.Warning.InternalPriceMissing": "Manca la base di costo interna per questo modello",
  "AgentModelSelection.Warning.PricingUnsupported": "Questo modello di fatturazione non è ancora supportato",
} as const;

export const sharedAgentModelSelectionTranslations = {
  de: sharedAgentModelSelectionDe,
  en: sharedAgentModelSelectionEn,
  ru: sharedAgentModelSelectionRu,
  uk: sharedAgentModelSelectionUk,
  it: sharedAgentModelSelectionIt,
} as const;

export type SharedAgentModelSelectionKey = keyof typeof sharedAgentModelSelectionDe;
